module.exports = __webpack_public_path__ + "static/travelzik6-2f0aa1355519935426368a0242846b31.png";